// Meta Pixel — código base oficial de Meta, inicializado al cargar el módulo (antes del render),
// con un guard global: un solo init y un solo PageView por carga de página.
const PIXEL_ID = '1127701643007506'

declare global {
  interface Window {
    __metaPixelInitialized?: boolean
  }
}

if (PIXEL_ID && typeof window !== 'undefined' && !window.__metaPixelInitialized) {
  window.__metaPixelInitialized = true
  /* eslint-disable */
  ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */
  ;(window as any).fbq('init', PIXEL_ID)
  ;(window as any).fbq('track', 'PageView')
}

export {}
